import { render, staticRenderFns } from "./Organizationold.vue?vue&type=template&id=72f0e6b3&scoped=true"
import script from "./Organizationold.vue?vue&type=script&lang=js"
export * from "./Organizationold.vue?vue&type=script&lang=js"
import style0 from "./Organizationold.vue?vue&type=style&index=0&id=72f0e6b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f0e6b3",
  null
  
)

export default component.exports